import { Box } from '@mantine/core';
import { IconPointFilled } from '@tabler/icons-react';
import { Outlet, createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import {
  travelAdminRoles,
  travelApproverRoles,
  travelDayBalancePeopleRoles,
  travelReportingRoles,
} from '@/module/Travel/travelRoles';

import { ContextSidebar } from '@/core/components/RootLayout/Sidebar/ContextSidebar';

import { RoleType, useRoleBoundary } from '@feature/security';

export const Route = createFileRoute('/_auth/travel/_travel')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.travel' },
  },
});

function RouteComponent() {
  const { t } = useTranslation();
  const { isRole, isRoleOneOf } = useRoleBoundary();

  const tabs = [
    { label: t('sidebar.travelRequests'), to: 'requests', icon: IconPointFilled, visible: isRole(RoleType.AUTHOR) },
    {
      label: t('sidebar.travelApprovals'),
      to: 'approvals',
      icon: IconPointFilled,
      visible: isRoleOneOf([...travelApproverRoles]),
    },
    // Only the research chain has a board step.
    {
      label: t('sidebar.travelBoardRequests'),
      to: 'board-requests',
      icon: IconPointFilled,
      visible: isRole(RoleType.RESEARCH_ADMINISTRATIVE_OFFICE),
    },
    // The backend scopes the registry rows by role, so every travel role gets the tab.
    { label: t('sidebar.travelRegistry'), to: 'registry', icon: IconPointFilled, visible: true },
    {
      label: t('sidebar.travelAnalytics'),
      to: 'analytics',
      icon: IconPointFilled,
      visible: isRoleOneOf([...travelReportingRoles]),
    },
    {
      label: t('sidebar.travelSettings'),
      to: 'settings',
      icon: IconPointFilled,
      visible: isRoleOneOf([...travelAdminRoles]),
    },
    {
      label: t('sidebar.travelDays'),
      to: 'days',
      icon: IconPointFilled,
      visible: isRole(RoleType.AUTHOR) || isRoleOneOf([...travelDayBalancePeopleRoles]),
    },
    { label: t('sidebar.travelDocuments'), to: 'documents', icon: IconPointFilled, visible: true },
  ];

  return (
    <>
      <ContextSidebar
        baseUrl="travel"
        items={tabs.filter(tab => tab.visible)}
      />
      <Box p="md">
        <Outlet />
      </Box>
    </>
  );
}
